export default __webpack_public_path__ + "static/media/calender-icon.45ce36b7.svg";